import { useParam } from "@blitzjs/next"
import { useInfiniteQuery } from "@blitzjs/rpc"
import getPaywallTemplates, { TPaywallTemplates } from "app/paywalls/queries/getPaywallTemplates"
import getPaywallTemplatesPublic from "app/paywalls/queries/getPaywallTemplatesPublic"
import { flattenDeep } from "es-toolkit"

const useGetPaywallTemplates = (v4Only: boolean, publicTemplates: boolean = false) => {
  const applicationId = useParam("applicationId", "number")!

  const query = publicTemplates ? getPaywallTemplatesPublic : getPaywallTemplates
  const [data, queryExtra] = useInfiniteQuery(
    query,
    (page = { take: 100, skip: 0 }) => ({
      ...page,
      applicationId,
      v4Only,
    }),
    {
      getNextPageParam: (lastPage) => lastPage.nextPage,
      suspense: false,
    }
  )

  const allPaywalls = data?.map((page) => page.paywallTemplates) || []
  const flattenedData = flattenDeep(allPaywalls)
  const lastData = data && data[data.length - 1]

  const { isFetching, isFetchingNextPage, fetchNextPage } = queryExtra

  if (!isFetching && !isFetchingNextPage && lastData?.nextPage) {
    fetchNextPage()
  }
  return {
    data: { ...lastData, paywallTemplates: flattenedData } as TPaywallTemplates,
    ...queryExtra,
  }
}

export default useGetPaywallTemplates
